export default __webpack_public_path__ + "static/media/delete-icon-cms.d487f26b.svg";